import BlockLoader from './BlockLoader'

export default BlockLoader
